import React from 'react';
import PropTypes from 'prop-types';
import { Container, Loader } from 'semantic-ui-react';
import ActionPanel from './ActionPanel';
import PendingActivationBanner from './components/PendingActivationBanner';
import UnsavedChangesGuard from './components/UnsavedChangesGuard';
import GroupedRuleList from './components/GroupedRuleList';
import './styles.css';

const EligibilityEnginePageView = ({
  themeClass,
  rules,
  isRulesLoading,
  rulesError,
  products,
  selectedProduct,
  selectedProductData,
  productType,
  hasUnsavedChanges,
  onRevert,
  onPublish,
  fetchRules,
  onProductChange,
  onIfNullChange,
  upsertNote,
}) => (
  <div
    id='eligibility-engine-page'
    data-testid='eligibility-engine-page'
    className={`theme ${themeClass}`}
  >
    <UnsavedChangesGuard />
    <ActionPanel
      products={products}
      selectedProduct={selectedProduct}
      selectedProductData={selectedProductData}
      productType={productType}
      themeClass={themeClass}
      hasUnsavedChanges={hasUnsavedChanges}
      onRevert={onRevert}
      onPublish={onPublish}
      fetchRules={fetchRules}
      onProductChange={onProductChange}
    />
    <Container>
      <PendingActivationBanner />
      <div className='fields-container'>
        {isRulesLoading ? (
          <Loader
            active
            inline='centered'
            content='Loading rules...'
            data-testid='rules-loading'
          />
        ) : rulesError ? (
          <div data-testid='rules-error'>
            Error loading rules. Please try again.
          </div>
        ) : (
          <GroupedRuleList
            rules={rules}
            onIfNullChange={onIfNullChange}
            upsertNote={upsertNote}
            selectedProduct={selectedProduct}
          />
        )}
      </div>
    </Container>
  </div>
);

EligibilityEnginePageView.propTypes = {
  themeClass: PropTypes.string.isRequired,
  rules: PropTypes.array.isRequired,
  isRulesLoading: PropTypes.bool.isRequired,
  rulesError: PropTypes.object,
  products: PropTypes.array.isRequired,
  selectedProduct: PropTypes.string.isRequired,
  selectedProductData: PropTypes.object,
  productType: PropTypes.string.isRequired,
  hasUnsavedChanges: PropTypes.bool.isRequired,
  onRevert: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  fetchRules: PropTypes.func.isRequired,
  onProductChange: PropTypes.func.isRequired,
  onIfNullChange: PropTypes.func.isRequired,
  upsertNote: PropTypes.func.isRequired,
};

EligibilityEnginePageView.defaultProps = {
  rulesError: null,
  selectedProductData: null,
};

export default EligibilityEnginePageView;
